module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQAQMAAAC032DuAAAABlBMVEX///89PT1L8aESAAAAE0lEQVR4AWMYkmAUMP4fisxRJgAZpSgBsDVVZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/projects/maria-jose-moreno/project-logo.png
// module id = 50
// module chunks = 0